import { useAtomValue } from 'jotai'
import {
  invoiceCurrencyAtom,
  invoiceCustomerBillingAddressAtom
} from 'Invoices/atoms/invoiceEditing.atom'
import { usePaymentProviderForInvoice } from 'Invoices/hooks/usePaymentProviderForInvoice'
import { getGoCardlessDisabledReason } from 'Integrations/index'

type GoCardlessAvailability = {
  isEnabled: boolean
  isAvailable: boolean
  disabledReason: string | null
}

export const useGoCardlessAvailability = (): GoCardlessAvailability => {
  const paymentProvider = usePaymentProviderForInvoice()
  const currency = useAtomValue(invoiceCurrencyAtom)
  const billingAddress = useAtomValue(invoiceCustomerBillingAddressAtom)

  const isEnabled = paymentProvider === 'GOCARDLESS'
  const otherProviderActive =
    paymentProvider !== 'NONE' && paymentProvider !== 'GOCARDLESS'

  const disabledReason = getGoCardlessDisabledReason({
    otherProviderActive,
    currency: currency ?? undefined,
    country: billingAddress?.country,
    hasCustomer: true,
    hasProducts: true
  })

  const isAvailable = disabledReason === null

  return { isEnabled, isAvailable, disabledReason }
}
